import { makeCrud, makeCrudHooks } from '../../lib/crud';

export const itinerariesCrud = makeCrud('/itineraries');
export const itinerariesHooks = makeCrudHooks('itineraries', itinerariesCrud);

// request_json / response_json arrive as JSON strings. Parse defensively.
export function parseJson(v) {
  if (!v) return null;
  if (typeof v === 'object') return v;
  try { return JSON.parse(v); } catch { return null; }
}

// The generated itinerary lives at response_json.data.detailed_itinerary.
export function detailOf(row) {
  const parsed = parseJson(row.response_json);
  return parsed?.data?.detailed_itinerary || null;
}

// The user's generation request.
export function requestOf(row) {
  return parseJson(row.request_json) || {};
}

function fmtDate(s) {
  if (!s) return '—';
  const d = new Date(s);
  return isNaN(d) ? s : d.toLocaleDateString();
}

export const itinerariesConfig = {
  key: 'itineraries', title: 'Itineraries', singular: 'Itinerary', hooks: itinerariesHooks,
  canCreate: false, canEdit: false, // AI-generated records — read + delete only
  detailPath: (row) => `/itineraries/${row.id}`,
  columns: [
    {
      key: 'name', header: 'Itinerary', render: (r) => {
        const det = detailOf(r);
        return det?.name || <span className="muted">#{r.id}</span>;
      },
    },
    {
      key: 'destination', header: 'Destination', render: (r) => {
        const det = detailOf(r);
        if (!det) return '—';
        return [det.city, det.state].filter(Boolean).join(', ') || '—';
      },
    },
    {
      key: 'days', header: 'Days', render: (r) => {
        const det = detailOf(r);
        return det?.total_days ?? requestOf(r).trip_duration ?? '—';
      },
    },
    {
      key: 'group', header: 'Group', render: (r) => {
        const req = requestOf(r);
        const parts = [req.travel_group_type, req.number_of_people && `${req.number_of_people} ppl`].filter(Boolean);
        return parts.join(' · ') || '—';
      },
    },
    {
      key: 'status', header: 'Status', render: (r) => (
        <span className={`badge badge--${(r.status || '').toLowerCase() === 'success' ? 'app' : ''}`}>{r.status || '—'}</span>
      ),
    },
    {
      key: 'tokens', header: 'Tokens', render: (r) => {
        const inTok = r.input_token, outTok = r.output_token;
        if (inTok == null && outTok == null) return '—';
        return <span className="muted">{(inTok ?? 0)} in / {(outTok ?? 0)} out</span>;
      },
    },
    { key: 'created_at', header: 'Date', render: (r) => fmtDate(r.created_at) },
  ],
  // No create/edit form — these records are produced by the generation pipeline.
  fields: [],
};
